import { render, staticRenderFns } from "./commercial-notice-card.vue?vue&type=template&id=8adcdcd8&scoped=true&"
import script from "./commercial-notice-card.vue?vue&type=script&lang=js&"
export * from "./commercial-notice-card.vue?vue&type=script&lang=js&"
import style0 from "./commercial-notice-card.vue?vue&type=style&index=0&id=8adcdcd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adcdcd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8adcdcd8')) {
      api.createRecord('8adcdcd8', component.options)
    } else {
      api.reload('8adcdcd8', component.options)
    }
    module.hot.accept("./commercial-notice-card.vue?vue&type=template&id=8adcdcd8&scoped=true&", function () {
      api.rerender('8adcdcd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/commercial-notices/partials/commercial-notice-card.vue"
export default component.exports